// extracted by mini-css-extract-plugin
export var bottomLabel = "StickyCruisePrice-module--bottom-label--c3e29";
export var container = "StickyCruisePrice-module--container--9a1c1";